import { COUNTDOWN_OFFERS_EXPERIENCE_ID } from 'components/DebtGroup'
import {
  SYSTEM_TOKEN,
  SYSTEM_TOKEN_COUNTDOWN_AB_TEST,
  SYSTEM_TOKEN_REDE,
  SYSTEM_TOKEN_PIVO,
  SYSTEM_TOKEN_LOJAS_AVENIDA,
  SYSTEM_TOKEN_RENEG,
  SYSTEM_TOKEN_BFF_RECOVERY,
  SYSTEM_TOKEN_BFF_REDE,
  SYSTEM_TOKEN_BFF_PIVO,
  SYSTEM_TOKEN_BFF_LOJAS_AVENIDA,
  SYSTEM_TOKEN_BFF_ITAU_CARTOES,
  SYSTEM_TOKEN_BFF_HUB,
  SYSTEM_TOKEN_BFF_ITI,
  SYSTEM_TOKEN_BFF_IQ,
  SYSTEM_TOKEN_BFF_PRICING,
} from 'gatsby-env-variables'
import storage from 'utils/storage'
import { getOptimizeVariant } from './getOptimizeVariant'
import { isPivo } from './isPivo'

const validateTheme = () => {
  const isLojasAvenida = storage.local.getItem('isLojasAvenida') === true

  const options = (isPivo() && 'pivo') || (isLojasAvenida && 'lojasAvenida')

  const theme = options || storage.session.getItem('theme') || 'recovery'

  return theme
}

export const getSystemToken = async () => {
  const isTimedout = storage.local.getItem('timedout')

  const countdownTimerVariant = await getOptimizeVariant(
    COUNTDOWN_OFFERS_EXPERIENCE_ID
  )

  const systemTokens = {
    recovery:
      countdownTimerVariant === '1' && isTimedout
        ? SYSTEM_TOKEN_COUNTDOWN_AB_TEST
        : SYSTEM_TOKEN,
    itaucard: SYSTEM_TOKEN, // Usado para o teste a/b com o fluxo laranja
    rede: SYSTEM_TOKEN_REDE,
    pivo: SYSTEM_TOKEN_PIVO,
    lojasAvenida: SYSTEM_TOKEN_LOJAS_AVENIDA,
  }

  return validateTheme() ? systemTokens[validateTheme()] : systemTokens.recovery
}

export const getSystemTokenBFF = async () => {
  const isTimedout = storage.local.getItem('timedout')

  const countdownTimerVariant = await getOptimizeVariant(
    COUNTDOWN_OFFERS_EXPERIENCE_ID
  )

  const systemTokensBFF = {
    recovery:
      countdownTimerVariant === '1' && isTimedout
        ? SYSTEM_TOKEN_COUNTDOWN_AB_TEST
        : SYSTEM_TOKEN_BFF_RECOVERY,
    itaucard: SYSTEM_TOKEN_BFF_RECOVERY, // Usado para o teste a/b com o fluxo laranja
    reneg: SYSTEM_TOKEN_RENEG,
    rede: SYSTEM_TOKEN_BFF_REDE,
    pivo: SYSTEM_TOKEN_BFF_PIVO,
    lojasAvenida: SYSTEM_TOKEN_BFF_LOJAS_AVENIDA,
    cartoes: SYSTEM_TOKEN_BFF_ITAU_CARTOES,
    hub: SYSTEM_TOKEN_BFF_HUB,
    iti: SYSTEM_TOKEN_BFF_ITI,
    iq: SYSTEM_TOKEN_BFF_IQ,
    pricing: SYSTEM_TOKEN_BFF_PRICING,
  }

  return validateTheme()
    ? systemTokensBFF[validateTheme()]
    : systemTokensBFF.recovery
}
